import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialMonitoringIssueDocumentState: Dtos.MonitoringIssueDocument & IRegistrationFormState = {
    id: null,
    monitoringIssueId: null,
    monitoringIssue: null,
    name: null,
    location: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface IMonitoringIssueDocumentReduxFormState {
    id: IFieldState<number>,
    monitoringIssueId: IFieldState<number>,
    monitoringIssue: IFieldState<Dtos.MonitoringIssue>,
    name: IFieldState<string>,
    location: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    saveAndReturn: IFieldState<boolean>,
}
